//
// AGNES - Technical Support Web
//
// TechnicalSupportPendingController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

angular.module("Agnes")
    .controller("TechnicalSupportBrowseController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, oidc) {
            // Storage
            $scope.$storage = $sessionStorage.$default({
                technicalSupportBrowse: {
                    search: null,
                    status: [1, 2, 3, 4, 5, 6, 7],
                    from: null,
                    to: null,
                    orderName: "CreateDate",
                    orderDesc: true
                }
            });

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            // Date pickers
            $scope.fromOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.fromOpened = true;
            };

            $scope.toOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.toOpened = true;
            };

            // Browse
            $scope.sorting = function (orderName) {
                if ($scope.$storage.technicalSupportBrowse.orderName === orderName) {
                    $scope.$storage.technicalSupportBrowse.orderDesc = !$scope.$storage.technicalSupportBrowse.orderDesc;
                } else {
                    $scope.$storage.technicalSupportBrowse.orderName = orderName;
                    $scope.$storage.technicalSupportBrowse.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.technicalSupportBrowse.orderName === orderName) {
                    if ($scope.$storage.technicalSupportBrowse.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.loadStatuses = function () {
                $activity.start();
                $http
                    .get("/api/technical-support-status", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.statuses = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.refresh = function () {
                $activity.start();
                $http
                    .get("/api/technical-support/browse/" + $scope.$storage.repairer.id, {
                        params: {
                            search: $scope.$storage.technicalSupportBrowse.search,
                            status: $scope.$storage.technicalSupportBrowse.status,
                            from: $scope.$storage.technicalSupportBrowse.from,
                            to: $scope.$storage.technicalSupportBrowse.to
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }

                    })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            // On Load
            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1) {
                $scope.loadStatuses();
                $scope.refresh();
            }
        }
    ]);